import React from 'react';
import PropTypes from 'prop-types';
import * as S from './MenuMoreStyles';

function MenuMore({ items }) {
  return (
    <S.Menu data-testid="card-menu">
      {items.map(item => (
        <S.Item key={item.id} onClick={item.action}>
          <S.MenuText>{item.label}</S.MenuText>
        </S.Item>
      ))}
    </S.Menu>
  );
}

MenuMore.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default MenuMore;
